import PropTypes from 'prop-types';
import React, { useState, useEffect } from 'react';
import { Table, Card } from 'react-bootstrap';
import 'react-loading-skeleton/dist/skeleton.css';
import { useToast } from 'context/providers/ToastProvider';
import ModalActualizarPaqueteAkasiaPOS from './ModalActualizarPaqueteAkasiaPOS';
import ModalRenovarPaqueteAkasiaPOS from './ModalRenovarPaqueteAkasiaPOS';
import IconButton from 'components/common/IconButton';
import useToken from 'hooks/useToken';

const SeccionModulosPaquete = (
    {
        

        idLicencia,

        setModulosExtraVinculados,


        DescripcionPaqueteAkasiaPOS,
        setDescripcionPaqueteAkasiaPOS,


        akasiaPOSWebPaquetes,
        setAkasiaPOSWebPaquetes


    }
) => {

    const { token } = useToken();
    const { showErrorToast } = useToast();


    // Para renovar paquete
    const [showModalActualizarPaqueteAkasiaPOS, setShowModalActualizarPaqueteAkasiaPOS] = useState(false);

    //Para Actualizar Paquete 
    const [showModalRenovarPaqueteAkasiaPOS, setShowModalRenovarPaqueteAkasiaPOS] = useState(false);

    // Estados locales que solo se usan en este componente
    const [akasiaPOSModulosPorPaquete, setAkasiaPOSModulosPorPaquete] = useState([]);
    const [idAkasiaPOSWebPaquetes, setIdAkasiaPOSWebPaquetes] = useState(0);
    const [CodigoPaqueteAkasiaPOS, setCodigoPaqueteAkasiaPOS] = useState("");

    const obtenerDatosAkasiaPos = async () => {
        try {
            const response = await fetch(`/api/licencia/ObtenerDatosAkasiaPos/?id=${idLicencia}`, {
                method: 'GET',
                headers: {
                    'Authorization': 'Bearer ' + token,
                    'Content-Type': 'application/json'
                }
            });

            if (!response.ok) {
                if (response.status === 401) {
                    localStorage.removeItem('token');
                    window.location.href = "";
                    return;
                }
                throw new Error(`${response.status} ${response.statusText}`);
            }

            const data = await response.json();

            if (data.iResponseType === 1) {

                const ObjDetalles = JSON.parse(data.detalles);
                console.log("DATA SECCION MODULOS PAQUETES", ObjDetalles)

                if (ObjDetalles.table2[0]?.idAkasiaPOSWebPaquetes) {
                    setIdAkasiaPOSWebPaquetes(ObjDetalles.table2[0].idAkasiaPOSWebPaquetes);
                }
                if (ObjDetalles.table2[0]?.vCodigoPaqueteAkasiaPOS) {
                    setCodigoPaqueteAkasiaPOS(ObjDetalles.table2[0].vCodigoPaqueteAkasiaPOS);
                }
               

                setAkasiaPOSModulosPorPaquete(ObjDetalles.table3);


                //Paquetes akasiaPOSWebPaquetes
                setAkasiaPOSWebPaquetes(ObjDetalles.table4);
               


            //    setModulosExtraVinculados(ObjDetalles.table5 || []);
            }
        } catch (error) {
            showErrorToast(error.message);
            console.error('Error al obtener datos de AkasiaPOS:', error);
        }
    };

    useEffect(() => {
        obtenerDatosAkasiaPos();
    }, [idLicencia]);

    return (
        <>
            <style>
                {`
                    .btn-success-dark {
                        background-color: #00b33c;
                        border-color: #00b33c;
                        color: #fff;
                    }

                    .btn-success-dark:hover {
                        background-color: #00802b;
                        border-color: #00802b;
                        color: #fff;

                    }
    
                `}
            </style>

            <Card className="shadow-sm">
                <Card.Body className="p-0">
                    {akasiaPOSModulosPorPaquete.length > 0 ? (
                        <>
                            {/* Validación: si algún módulo tiene status 'VENCIDO' */}
                            {akasiaPOSModulosPorPaquete.some(mod => mod.vStatus?.toUpperCase() === 'VENCIDO') ? (
                                <div className="alert alert-warning d-flex justify-content-between align-items-center p-3">
                                    <span className="me-2">
                                        ⚠️ El periodo de uso de este paquete se ha vencido.
                                        Es necesario que se renueve para seguir utilizando todas las funcionalidades.
                                    </span>
                                    <div>
                                        <IconButton
                                            variant="success"
                                            size="sm"
                                            icon="rotate"
                                            iconAlign="left"
                                            onClick={() => setShowModalRenovarPaqueteAkasiaPOS(true)} // ✅ Esto sí está bien
                                            className="me-2"
                                        >
                                            Renovar
                                        </IconButton>
                                        <IconButton
                                            variant="primary"
                                            size="sm"
                                            icon="fa-gear"
                                            iconAlign="left"
                                            onClick={() => setShowModalActualizarPaqueteAkasiaPOS(true)}
                                        >
                                            Actualizar
                                        </IconButton>
                                    </div>
                                </div>
                            ) : (
                                <div className="d-flex justify-content-center mt-0 mb-3">
                                    <IconButton
                                        variant="primary"
                                        size="sm"
                                        icon="rotate"
                                        iconAlign="left"
                                        onClick={() => setShowModalActualizarPaqueteAkasiaPOS(true)}
                                    >
                                        Actualizar Paquete
                                    </IconButton>
                                </div>
                            )}


                            <Table responsive bordered hover className="mb-0">
                                <thead className="table-light">
                                    <tr>
                                        <th className="text-start">Descripci&oacute;n</th>
                                        <th className="text-start">C&oacute;digo</th>
                                        <th className="text-start">Fecha de Vencimiento</th>
                                        <th className="text-start">Status</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {akasiaPOSModulosPorPaquete.map((modulo, index) => (
                                        <tr key={index}>
                                            <td className="text-start text-muted">{modulo.vDescripcionModulo}</td>
                                            <td className="text-start text-muted">{modulo.vCodigoModulo}</td>
                                            <td className="text-start text-muted">{modulo.dFinModuloUso}</td>
                                            <td className="text-start">
                                                <span className={`badge fw-medium ${modulo.vStatus === 'VENCIDO'
                                                    ? 'bg-danger-subtle text-danger'
                                                    : 'bg-success-subtle text-success'
                                                    }`}>
                                                    {modulo.vStatus}
                                                </span>
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </Table>
                        </>
                    ) : (
                        <p className="mb-0 text-muted">Este paquete aún no tiene módulos registrados.</p>
                    )}
                </Card.Body>
            </Card>

            <ModalRenovarPaqueteAkasiaPOS
                idLicencia={idLicencia}
                setAkasiaPOSModulosPorPaquete={setAkasiaPOSModulosPorPaquete}
                idAkasiaPOSWebPaquetes={idAkasiaPOSWebPaquetes}
                CodigoPaqueteAkasiaPOS={CodigoPaqueteAkasiaPOS}
                DescripcionPaqueteAkasiaPOS={DescripcionPaqueteAkasiaPOS}
                showModalRenovarPaqueteAkasiaPOS={showModalRenovarPaqueteAkasiaPOS}
                setShowModalRenovarPaqueteAkasiaPOS={setShowModalRenovarPaqueteAkasiaPOS}
            ></ModalRenovarPaqueteAkasiaPOS>

            <ModalActualizarPaqueteAkasiaPOS
                idLicencia={idLicencia}
                akasiaPOSWebPaquetes={akasiaPOSWebPaquetes}
                setAkasiaPOSModulosPorPaquete={setAkasiaPOSModulosPorPaquete}
                CodigoPaqueteAkasiaPOS={CodigoPaqueteAkasiaPOS}
                setCodigoPaqueteAkasiaPOS={setCodigoPaqueteAkasiaPOS}
                setIdAkasiaPOSWebPaquetes={setIdAkasiaPOSWebPaquetes}
                setDescripcionPaqueteAkasiaPOS={setDescripcionPaqueteAkasiaPOS}
                showModalActualizarPaqueteAkasiaPOS={showModalActualizarPaqueteAkasiaPOS}
                setShowModalActualizarPaqueteAkasiaPOS={setShowModalActualizarPaqueteAkasiaPOS}
                setAkasiaPOSWebPaquetes={setAkasiaPOSWebPaquetes}
                setModulosExtraVinculados={setModulosExtraVinculados}
            ></ModalActualizarPaqueteAkasiaPOS>

        </>
    )
}

SeccionModulosPaquete.propTypes = {


    idLicencia: PropTypes.string,

    setModulosExtraVinculados: PropTypes.func,


    DescripcionPaqueteAkasiaPOS: PropTypes.string,
    setDescripcionPaqueteAkasiaPOS: PropTypes.func,


    setAkasiaPOSWebPaquetes: PropTypes.func,
    akasiaPOSWebPaquetes: PropTypes.array,


};


export default SeccionModulosPaquete;